import React from "react";
import { useEffect } from "react";
import ReactDOM from "react-dom";
import { ToastContainer } from "react-toastify";
import Container from "./components/container/container.js";
import "../../../../shared/styles/colorDefinitions.css";
import "../../style.css";
export default function OrderIndex(props) {
    useEffect(() => {
        document.title = "Podsumowanie zamówienia Klienta";
    }, []);
    return (React.createElement("div", null,
        React.createElement(Container, null),
        React.createElement(ToastContainer, { position: "top-left", hideProgressBar: true })));
}
// eslint-disable-next-line react/no-deprecated
ReactDOM.render(React.createElement(OrderIndex, null), document.querySelector("#container"));
